import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API, useAuth } from '../contexts/AuthContext';

const PAGE = 50;

function formatNumero(numero) {
  if (!numero) return '—';
  const limpo = String(numero).replace(/\D/g, '');
  if (limpo.length === 11) return `(${limpo.slice(0, 2)}) ${limpo.slice(2, 7)}-${limpo.slice(7)}`;
  if (limpo.length === 10) return `(${limpo.slice(0, 2)}) ${limpo.slice(2, 6)}-${limpo.slice(6)}`;
  return numero;
}

export default function MartelinhoHistorico() {
  const { temPermissao } = useAuth();
  const [registros, setRegistros] = useState([]);
  const [total, setTotal] = useState(0);
  const [offset, setOffset] = useState(0);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');

  const podeVer = temPermissao('martelinho:visualizar', 'martelinho:gerenciar');

  useEffect(() => {
    if (!podeVer) { setLoading(false); return; }
    setLoading(true);
    axios.get(`${API}/martelinho/historico?limit=${PAGE}&offset=${offset}`)
      .then((res) => {
        setRegistros(res.data?.data?.records || []);
        setTotal(res.data?.data?.total || 0);
        setErro('');
      })
      .catch(() => setErro('Não foi possível carregar o histórico.'))
      .finally(() => setLoading(false));
  }, [podeVer, offset]);

  if (!podeVer) {
    return (
      <div className="container py-4">
        <div className="alert alert-warning">Você não tem permissão para ver o histórico do Martelinho.</div>
      </div>
    );
  }

  const paginaAtual = Math.floor(offset / PAGE) + 1;
  const totalPaginas = Math.max(1, Math.ceil(total / PAGE));

  return (
    <div className="container py-4">
      <div className="mb-4">
        <h3 className="mb-1" style={{ color: 'var(--portal-text)' }}>Histórico de alterações</h3>
        <p className="text-muted mb-0" style={{ fontSize: '0.85rem' }}>
          Alterações feitas pelo bot (venda sem estoque, devolução). Total: {total}.
        </p>
      </div>

      {erro && <div className="alert alert-danger">{erro}</div>}

      <div className="card p-0">
        {loading ? (
          <div className="text-center py-5"><div className="spinner-border" /></div>
        ) : registros.length === 0 ? (
          <div className="p-4 text-center text-muted">Nenhum registro.</div>
        ) : (
          <div className="table-responsive">
            <table className="table table-hover mb-0" style={{ color: 'var(--portal-text)' }}>
              <thead>
                <tr>
                  <th>Data/Hora</th>
                  <th>Nome</th>
                  <th>Número</th>
                  <th>Módulo</th>
                  <th>Produto</th>
                  <th>Situação</th>
                </tr>
              </thead>
              <tbody>
                {registros.map((r, i) => (
                  <tr key={`${r.codigo_produto}-${r.data_hora}-${i}`}>
                    <td>{r.data_hora ? new Date(r.data_hora).toLocaleString('pt-BR') : '—'}</td>
                    <td>{r.nome || '—'}</td>
                    <td style={{ fontFamily: 'monospace' }}>{formatNumero(r.numero)}</td>
                    <td>{r.permissao_modulo || '—'}</td>
                    <td>{r.codigo_produto || '—'}</td>
                    <td>{r.nova_situacao || '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {totalPaginas > 1 && (
        <div className="d-flex justify-content-between align-items-center mt-3">
          <button
            className="btn btn-sm btn-outline-secondary"
            disabled={offset === 0}
            onClick={() => setOffset(Math.max(0, offset - PAGE))}
          >
            <i className="bi bi-chevron-left" /> Anterior
          </button>
          <span style={{ fontSize: '0.85rem', color: 'var(--portal-muted)' }}>
            Página {paginaAtual} de {totalPaginas}
          </span>
          <button
            className="btn btn-sm btn-outline-secondary"
            disabled={paginaAtual >= totalPaginas}
            onClick={() => setOffset(offset + PAGE)}
          >
            Próxima <i className="bi bi-chevron-right" />
          </button>
        </div>
      )}
    </div>
  );
}
